import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React from 'react';
import { useStyles, StyleSheet, text, padding, margin } from '@rexlabs/styling';
import { isCustomElementActionMenuItem, isDividerActionMenuItem, isGroupHeadingActionMenuItem } from './types';
var defaultStyles = StyleSheet({
  list: {
    listStyleType: 'none'
  },
  listItem: {
    position: 'relative',
    margin: 0,
    padding: 0,
    listStyle: 'none'
  },
  menuItem: _objectSpread(_objectSpread({
    cursor: 'pointer',
    display: 'block',
    width: '100%'
  }, text.styles({
    target: 'actionMenu.item',
    fallback: 'normal.default'
  })), padding.styles({
    target: 'actionMenu.item',
    x: 'm',
    y: 's'
  })),
  menuItemDanger: {
    '&&, &&:hover, &&:focus': {
      color: function color(_ref) {
        var token = _ref.token;
        return token('color.textStyle.danger.idle.default');
      }
    }
  },
  menuItemDisabled: {
    opacity: 0.4
  },
  menuItemHighlighted: {
    backgroundColor: function backgroundColor(_ref2) {
      var token = _ref2.token;
      return token('actionMenu.item.hover.background.color', token('color.container.interactive.hover'));
    }
  },
  divider: _objectSpread(_objectSpread({
    width: '100%',
    height: '.1rem',
    display: 'flex'
  }, margin.styles({
    target: 'actionMenu.divider',
    all: 'none'
  })), {}, {
    backgroundColor: function backgroundColor(_ref3) {
      var token = _ref3.token;
      return token('actionMenu.divider.background.color', token('color.border.container.static.light'));
    }
  }),
  groupHeading: _objectSpread(_objectSpread({
    textTransform: 'uppercase'
  }, text.styles({
    target: 'actionMenu.heading',
    fallback: 'normal.semibold'
  })), padding.styles({
    target: 'actionMenu.heading',
    top: 's',
    x: 'xs',
    bottom: 'xs'
  }))
});
export function ActionMenuContent(_ref4) {
  var items = _ref4.items,
      highlightedIndex = _ref4.highlightedIndex,
      getItemProps = _ref4.getItemProps;
  var s = useStyles(defaultStyles);
  return /*#__PURE__*/React.createElement(React.Fragment, null, _mapInstanceProperty(items).call(items, function (item, index) {
    if (isGroupHeadingActionMenuItem(item)) {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, /*#__PURE__*/React.createElement("div", _extends({}, s('groupHeading'), getItemProps({
        item: item,
        index: index,
        disabled: true
      }), {
        role: "heading"
      }), item.label));
    }

    if (isDividerActionMenuItem(item)) {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, /*#__PURE__*/React.createElement("div", _extends({}, s('divider'), getItemProps({
        item: item,
        index: index,
        disabled: true
      }), {
        role: "separator"
      })));
    }

    if (isCustomElementActionMenuItem(item)) {
      var Content = item.Content;
      return /*#__PURE__*/React.createElement("li", _extends({}, s('listItem'), {
        key: index
      }), /*#__PURE__*/React.createElement(Content, _extends({}, s('menuItem'), getItemProps({
        item: item,
        index: index,
        disabled: item === null || item === void 0 ? void 0 : item.disabled,
        onClick: function onClick() {
          var _item$onClick;

          item === null || item === void 0 ? void 0 : (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item);
        }
      }), {
        tabIndex: 0
      })));
    }

    return /*#__PURE__*/React.createElement("li", _extends({}, s('listItem', {
      listItemDisabled: item.disabled
    }), {
      key: index
    }), /*#__PURE__*/React.createElement("a", _extends({}, s('menuItem', {
      menuItemDanger: item.intent === 'danger',
      menuItemDisabled: item.disabled,
      menuItemHighlighted: highlightedIndex === index
    }), getItemProps({
      item: item,
      index: index,
      disabled: item === null || item === void 0 ? void 0 : item.disabled,
      onClick: function onClick() {
        var _item$onClick2;

        item === null || item === void 0 ? void 0 : (_item$onClick2 = item.onClick) === null || _item$onClick2 === void 0 ? void 0 : _item$onClick2.call(item);
      }
    })), item.label));
  }));
}
export default ActionMenuContent;